import { GenIcon } from '../helpers/IconBase.es.js';

const StyledSearchOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 21 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_15936_797)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M20.2557 18.5781L15.2815 13.6039C16.637 11.9461 17.3035 9.83066 17.143 7.69522C16.9826 5.55977 16.0075 3.56769 14.4195 2.13102C12.8315 0.69434 10.752 -0.0770086 8.61119 -0.023482C6.4704 0.0300445 4.43207 0.904351 2.91783 2.41859C1.40359 3.93283 0.529282 5.97116 0.475755 8.11195C0.422229 10.2527 1.19358 12.3322 2.63025 13.9202C4.06693 15.5083 6.05901 16.4833 8.19445 16.6438C10.3299 16.8042 12.4453 16.1378 14.1032 14.7823L19.0773 19.7564C19.2345 19.9082 19.445 19.9922 19.6635 19.9903C19.882 19.9884 20.091 19.9008 20.2455 19.7463C20.4 19.5918 20.4877 19.3827 20.4895 19.1643C20.4914 18.9458 20.4075 18.7353 20.2557 18.5781ZM8.83315 15.0006C7.51461 15.0006 6.22568 14.6096 5.12935 13.877C4.03302 13.1445 3.17854 12.1033 2.67395 10.8851C2.16937 9.66696 2.03735 8.32652 2.29458 7.03331C2.55182 5.74011 3.18676 4.55222 4.11911 3.61987C5.05146 2.68752 6.23934 2.05258 7.53255 1.79535C8.82576 1.53811 10.1662 1.67013 11.3844 2.17472C12.6025 2.6793 13.6437 3.53379 14.3763 4.63011C15.1088 5.72644 15.4998 7.01537 15.4998 8.33392C15.4978 10.1014 14.7948 11.796 13.545 13.0458C12.2952 14.2956 10.6007 14.9986 8.83315 15.0006Z",
              fill: "black",
              fillOpacity: "0.65"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_15936_797" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "20",
                  height: "20",
                  fill: "white",
                  transform: "translate(0.5)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { StyledSearchOutlined };
